import axios from '@/utils/axios'

export const getOutStore = (payload) => {
    return axios.get('/out_store', {
        params: payload
    })
}

export const getOutStoreStat = (payload) => {
    return axios.get('/out_store_stat', {
        params: payload
    })
}

export const loadOutStoreInSalesStat = (data) => {
    return axios.post(`/load_out_store_in_sales_stat`, data)
}

// export const updateMaterial = (id, data) => {
//     return axios.put(`/material/${id}`, data)
// }


// export const getMaterialById = (id) => {
//     return axios.get(`/material/${id}`)
// }

// export const getRawMaterialWithPrice = (payload) => {
//     return axios.get('/raw_material_latest_price', {
//         params: payload
//     })
// }

// export const getSemiMaterialWithCost = (payload) => {
//     return axios.get('/semi_material_latest_cost', {
//         params: payload
//     })
// }

// export const createWater = (data) => {
//     return axios.post('/waterMaterial', data)
// }